import React from "react";

import { BannerView } from "./BannerView";

interface IState {
  show: boolean;
}

export enum StorageKeys {
  covidbanner = "covidbanner"
}

function getCovidBannerExpiry() {
  const itemStr = localStorage.getItem(StorageKeys.covidbanner);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    ``;
    // If the item is expired, delete the item from storage
    // and return null`
    localStorage.removeItem(StorageKeys.covidbanner);
    return null;
  }
  return item.value;
}

function setCovidBannerExpiry() {
  const now = new Date();
  // Expire in 24 hours
  const item = { value: "closed", expiry: now.getTime() + 1000 * 60 * 60 * 24 };
  localStorage.setItem(StorageKeys.covidbanner, JSON.stringify(item));
}

export class CovidBanner extends React.Component<any, IState> {
  state: IState = { show: true };

  onCloseButtonClick = () => {
    setCovidBannerExpiry();
    this.setState({ show: false });
  };

  componentDidMount() {
    try {
      const hasExpired = getCovidBannerExpiry();
      this.setState({ show: !hasExpired });
    } catch (error) {
      console.log("CrisisBanner Error:", error);
    }
  }

  render() {
    const { show } = { ...this.state } as IState;
    return show ? (
      <BannerView
        type="error"
        message={`View our COVID-19 customer support and financial assistance options in our <a style="color:currentcolor;" href="/coronavirus.html">Coronavirus update</a>.`}
        onCloseButtonClick={this.onCloseButtonClick}
        closeBtnDataId={"cbCloseBtn"}
      />
    ) : null;
  }
}
